import { useMutation } from 'react-query'

// Libs
import { addFavoriteRoom } from '@/api/addFavoriteRoom'
import { deleteFavoriteRoom } from '@/api/deleteFavoriteRoom'

// Constants

type UseFavoriteLiveParamsType = {
  mutationCallback?: () => void
}

export const useFavoriteLive = (props?: UseFavoriteLiveParamsType) => {
  const { mutationCallback } = props || {}
  const addFavoriteRoomMutation = useMutation(addFavoriteRoom)
  const deleteFavoriteRoomMutation = useMutation(deleteFavoriteRoom)
  const handleAddFavoriteLive = async (data: { roomId: string | number }) => {
    try {
      await addFavoriteRoomMutation.mutateAsync({
        data: {
          roomId: String(data.roomId),
        },
      })
      mutationCallback && mutationCallback()
      return { isSuccess: true }
    } catch (error) {
      return { isSuccess: false, error }
    }
  }
  const handleDeleteFavoriteLive = async (data: { roomId: string | number }) => {
    try {
      await deleteFavoriteRoomMutation.mutateAsync({
        data: {
          roomId: String(data.roomId),
        },
      })
      mutationCallback && mutationCallback()
      return { isSuccess: true }
    } catch (error) {
      return { isSuccess: false, error }
    }
  }

  return {
    handleAddFavoriteLive,
    handleDeleteFavoriteLive,
    isLoading: addFavoriteRoomMutation.isLoading || deleteFavoriteRoomMutation.isLoading,
  }
}
